export default __webpack_public_path__ + "static/media/world.775694a2.png";